import { createApp } from 'vue'
import App from './App.vue'
import AOS from 'aos';
import 'aos/dist/aos.css';
import '@justeattakeaway/pie-css/dist/index.css';
import Vue from 'vue'
import VueHead from 'vue-head'

AOS.init();

createApp(App).mount('#app');